import { KEY_PREFIX } from './constants';
export default function getStoredState(config) {
  var transforms = config.transforms || [];
  var prefix = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX)
  var storageKey = prefix.concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  function getPreparedState(getRawState) {
    try {
      var state = {};
      const rawState = getRawState()
      Object.keys(rawState).forEach(function (key) {
        state[ key ] = transforms.reduceRight(function (subState, transformer) {
          return transformer.out(subState, key, rawState);
        }, deserialize(rawState[ key ]));
      });
      return state;
    } catch (err) {
      if (process.env.NODE_ENV !== 'production' && debug) console.error("redux-persist/getStoredState: Error preparing data ".concat(serialized), err);
      throw err;
    }
  }

  if (config.multiKeys && config.keys) {
    const promises = config.keys.map(key => storage.getItem(`${storageKey}:${key}`).then(serialized => (serialized ? { key, serialized } : undefined)))
    return Promise.all(promises).then(results => {
      return getPreparedState(() => {
        return results
          .filter(result => !!result)
          .map(result => ({ ...result, deserialized: deserialize(result.serialized) }))
          .reduce((acc, result) => ({ ...acc, [ result.key ]: result.deserialized }), {});
      })
    })
  } else {
    return storage.getItem(storageKey).then(function (serialized) {
      if (!serialized) return undefined;
      else return getPreparedState(() => deserialize(serialized));
    });
  }
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}